import { gql } from "@apollo/client";

export const QUERY_ATTACHABLE_VCS_INTEGRATIONS = gql`
  query QueryAttachableVcsIntegration($spaceId: ID!, $provider: VCSProvider!) {
    attachableVCSIntegrationsForProviderInSpace(id: $spaceId, provider: $provider) {
      id
      name
      details {
        __typename
        ... on GithubEnterpriseIntegration {
          id
          githubAppStatus
          installations {
            installationId
          }
          useGitCheckout
        }
        ... on GitlabIntegration {
          id
          useGitCheckout
        }
        ... on AzureDevOpsRepoIntegration {
          id
          useGitCheckout
        }
        ... on BitbucketCloudIntegration {
          id
          useGitCheckout
        }
        ... on BitbucketDatacenterIntegration {
          id
          useGitCheckout
        }
        ... on BlobStorageIntegration {
          id
          useGitCheckout
        }
      }
    }
  }
`;
